export async function request(path, options = {}) {
  const response = await fetch(path, { cache: "no-store", ...options, headers: { accept: "application/json", ...(options.headers || {}) } });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error?.message || payload?.error || `HTTP ${response.status}`);
    error.code = payload?.error;
    error.status = response.status;
    error.outcomeUnknown = payload?.outcomeUnknown === true;
    throw error;
  }
  return payload;
}

const jsonOptions = (value) => ({ method: "POST", headers: { "content-type": "application/json", "idempotency-key": crypto.randomUUID() }, body: JSON.stringify(value) });

export const twinScopeApi = {
  listConnections: () => request("/api/twinscope/connections"),
  saveConnection: (id, value) => request(`/api/twinscope/connections/${encodeURIComponent(id)}`, { ...jsonOptions(value), method: "PUT" }),
  testConnection: value => request("/api/twinscope/connections/test", jsonOptions(value)),
  listPlants: () => request("/api/twinscope/plants"),
  moveNode: (plantId, nodeId, value) => request(`/api/twinscope/plants/${encodeURIComponent(plantId)}/nodes/${encodeURIComponent(nodeId)}/move`, jsonOptions({ ...value, confirmNodeId: nodeId })),
  deleteArea: (plantId, nodeId, revision) => request(`/api/twinscope/plants/${encodeURIComponent(plantId)}/nodes/${encodeURIComponent(nodeId)}/delete`, jsonOptions({ revision, confirmNodeId: nodeId })),
  listPublicPlants: () => request("/api/twinscope/plants/public"),
  savePlant: (id, value) => request(`/api/twinscope/plants/${encodeURIComponent(id)}`, { method: "PUT", headers: { "content-type": "application/json" }, body: JSON.stringify(value) }),
  integrationStatus: () => request("/api/twinscope/integrations/status"),
  listBindings: () => request("/api/twinscope/bindings"),
  createTwin: (value) => request("/api/twinscope/twins", jsonOptions(value)),
  deleteTwin: (twinId, value) => request(`/api/twinscope/twins/${encodeURIComponent(twinId)}/delete`, jsonOptions(value)),
  deleteTwinEvents: (twinId, value) => request(`/api/twinscope/twins/${encodeURIComponent(twinId)}/delete-events`, jsonOptions(value)),
  rotateTwinCredentials: (twinId, value) => request(`/api/twinscope/twins/${encodeURIComponent(twinId)}/device-credentials/rotate`, jsonOptions(value)),
  realtimeStatus: (twinId, objectId, plantId) => request(`/api/twinscope/twins/${encodeURIComponent(twinId)}/realtime/status?objectId=${encodeURIComponent(objectId)}&plantId=${encodeURIComponent(plantId)}`),
  realtimeLatest: (twinId, objectId, plantId) => request(`/api/twinscope/twins/${encodeURIComponent(twinId)}/realtime/latest?objectId=${encodeURIComponent(objectId)}&plantId=${encodeURIComponent(plantId)}`),
};

export function isIotaObjectId(value) {
  return /^0x[0-9a-f]{64}$/i.test(String(value || "").trim());
}
